import styled, { css } from 'styled-components';
import { boxStyles } from '../Box/styles.js';
import { contentTextPropExclusions, contentTextStyles } from '../ContentText/styles.web.js';
import { ContentText } from '../ContentText/ContentText.web.js';
import { Link } from '../Link/Link.web.js';

var breadcrumb = /*#__PURE__*/styled.nav.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !contentTextPropExclusions.has(prop);
  }
}).withConfig({
  displayName: "styles__breadcrumb",
  componentId: "sc-1ytpeno-0"
})(["display:flex;align-items:center;", " ", ""], boxStyles, contentTextStyles);
var labelStyles = /*#__PURE__*/css(["overflow:hidden;white-space:normal;word-break:break-word;overflow-wrap:break-word;margin:4px 0;"]);
var text = /*#__PURE__*/styled(ContentText).withConfig({
  displayName: "styles__text",
  componentId: "sc-1ytpeno-1"
})(["", ""], labelStyles);
var link = /*#__PURE__*/styled(Link).withConfig({
  displayName: "styles__link",
  componentId: "sc-1ytpeno-2"
})(["", ""], labelStyles);
var list = /*#__PURE__*/styled.ol.withConfig({
  displayName: "styles__list",
  componentId: "sc-1ytpeno-3"
})(["padding:0;margin:0;display:inline;max-width:100%;"]);
var item = /*#__PURE__*/styled.li.withConfig({
  displayName: "styles__item",
  componentId: "sc-1ytpeno-4"
})(["display:inline-flex;"]);

export { breadcrumb, item, link, list, text };
